var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNotification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V14C4 11.8783 4.84285 9.84344 6.34314 8.34315C7.84344 6.84285 9.87827 6 12 6C14.1217 6 16.1566 6.84285 17.6569 8.34315C19.1571 9.84344 20 11.8783 20 14V20H21V22H3V20H4ZM6 20H18V14C18 12.4087 17.3679 10.8826 16.2426 9.75736C15.1174 8.63214 13.5913 8 12 8C10.4087 8 8.88258 8.63214 7.75736 9.75736C6.63214 10.8826 6 12.4087 6 14V20ZM11 2H13V5H11V2ZM19.778 4.808L21.192 6.222L19.072 8.343L17.657 6.929L19.778 4.808ZM2.808 6.222L4.222 4.808L6.343 6.928L4.93 8.344L2.808 6.222ZM7 14C7 12.6739 7.52678 11.4021 8.46446 10.4645C9.40215 9.52678 10.6739 9 12 9V11C11.2043 11 10.4413 11.3161 9.87868 11.8787C9.31607 12.4413 9 13.2044 9 14H7Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification.51c805ce3c201c9508e5b2f9cca98a56.svg";